import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

//import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client';

import './index.css';
import { AuthProvider, AuthProviderType } from './Context/AuthContext.tsx';

import './assets/custom-theme.css';
import './assets/additional-styles.css';
import 'primeflex/primeflex.css';
import { AppContextProvider } from './Context/AppContext.tsx';

import App from './App';

console.log("========== App Startup [mian.tsx] ==========");

// Log all envs used to debug redirect issues
console.log("[main.tsx] ENV | VITE_OIDC_AUTHORITY:", import.meta.env.VITE_OIDC_AUTHORITY);
console.log("[main.tsx] ENV | VITE_OIDC_REDIRECT_URI:", import.meta.env.VITE_OIDC_REDIRECT_URI);
console.log("[main.tsx] ENV | VITE_OIDC_LOGOUT_REDIRECT_URI:", import.meta.env.VITE_OIDC_LOGOUT_REDIRECT_URI);
console.log("[main.tsx] ENV | VITE_AUTH_PROVIDER:", import.meta.env.VITE_AUTH_PROVIDER);

const rawAuthType = import.meta.env.VITE_AUTH_PROVIDER;

console.log("[main.tsx] Raw Auth Type from env:", JSON.stringify(rawAuthType));
console.log("[main.tsx] Length of raw auth type:", rawAuthType?.length);

const authProvider = (
  rawAuthType?.toLowerCase().trim() ?? 'siteminder'
) as AuthProviderType;

createRoot(document.getElementById('root')!).render(
  <AuthProvider authProvider={authProvider}>
    <AppContextProvider>
      <App />
    </AppContextProvider>
  </AuthProvider>
);

console.log("[main.tsx]React app rendered into #root");